<script setup lang="ts">
import type { KanbanLogActor } from '@entities/kanban-comment'

import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { KANBAN_LOG_EMPTY_VALUE } from '@entities/kanban-comment'
import { AppText } from '@shared/ui/typography'
import { IconContainer } from '@shared/ui/other'

import { useKanbanLogExtraFields } from '../../model/log/use-kanban-log-extra-fields.hook'
import KanbanLogItemInfo from './KanbanLogItemInfo.vue'

defineOptions({
  name: 'KanbanLogExtraFields',
})

const props = defineProps<{
  actor: KanbanLogActor | null
  oldValue: string | null
  value: string | null
}>()

const {
  refOldEntries,
  refNewEntries,
} = useKanbanLogExtraFields({
  oldValue: props.oldValue,
  value: props.value,
})
</script>

<template>
  <div class="kanban-log-field">
    <KanbanLogItemInfo
      :actor="actor"
      label="change extra fields"
    />
    <div class="kanban-log-field__row kanban-log-extra-fields">
      <div
        v-if="refOldEntries.length"
        class="kanban-log-extra-fields__list"
      >
        <div
          v-for="entry in refOldEntries"
          :key="entry.label"
          class="kanban-log-extra-fields__item"
        >
          <AppText
            name="body2-medium"
            color="slate-500"
          >
            {{ entry.label }}:
          </AppText>
          <AppText
            name="body2"
            color="slate-900"
          >
            {{ entry.value }}
          </AppText>
        </div>
      </div>
      <AppText
        v-else
        name="body2"
        color="slate-400"
        class="unassigned"
      >
        {{ KANBAN_LOG_EMPTY_VALUE }}
      </AppText>
      <IconContainer>
        <FontAwesomeIcon :icon="faArrowRight" />
      </IconContainer>
      <div
        v-if="refNewEntries.length"
        class="kanban-log-extra-fields__list"
      >
        <div
          v-for="entry in refNewEntries"
          :key="entry.label"
          class="kanban-log-extra-fields__item"
        >
          <AppText
            name="body2-medium"
            color="slate-500"
          >
            {{ entry.label }}:
          </AppText>
          <AppText
            name="body2"
            color="slate-900"
          >
            {{ entry.value }}
          </AppText>
        </div>
      </div>
      <AppText
        v-else
        name="body2"
        color="slate-400"
        class="unassigned"
      >
        {{ KANBAN_LOG_EMPTY_VALUE }}
      </AppText>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./KanbanLogExtraFields.scss" />